import BankSidebar from "./BankSidebar";
import Header from "./Header";
import PanelLayout from "./PanelLayout";
import useAuth from "../../hooks/useAuth";

export default function BankLayout() {
  const { auth } = useAuth();
  const bankName = auth?.user?.bank?.bankName || "Bank Panel";

  return (
    <PanelLayout
      brand={bankName}
      sidebar={<BankSidebar />}
      header={<Header />}
    />
  );
}
